import { GitBranch, Loader2 } from 'lucide-react'
import { cn } from '@/lib/cn'
import type { LiveStatusData } from './stream'

/** The terminal's bottom lines (ONE-9): branch, shells, agents still working, room before auto-compact. */
export function LiveStatus({ s }: { s: LiveStatusData }) {
  const compact = s.untilCompact !== null && s.untilCompact <= 30
  if (!s.branch && !s.shells && !s.waiting && !s.agents.length && !compact) return null
  return (
    <div className="-mt-2 flex flex-col gap-1 text-[11px] text-fg-subtle">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        {s.branch && <span className="flex items-center gap-1 font-mono" title="Branch checked out in this session"><GitBranch size={11} />{s.branch}</span>}
        {s.waiting > 0 && <span className="flex items-center gap-1"><Loader2 size={11} className="animate-spin text-accent" />Waiting for {s.waiting} background agent{s.waiting > 1 ? 's' : ''}</span>}
        {s.shells > 0 && <span className="text-accent-hover">{s.shells} shell{s.shells > 1 ? 's' : ''} running</span>}
        {compact && <span className={cn('ml-auto', s.untilCompact! <= 10 && 'text-warn')}>{s.untilCompact}% until auto-compact</span>}
      </div>
      {s.agents.map((a) => <div key={a.id} className="truncate pl-4 font-mono text-fg-faint">○ {a.text}</div>)}
    </div>
  )
}
